import React, { useState, Fragment } from "react";
import { useStylesApp } from "hooks/useStyles";
import { useSelector } from "react-redux";

//mostrar empresa
import {
  Grid,
  Card,
  withStyles,
  InputBase,
  Divider,
  CardHeader,
  Typography,
  Backdrop,
  FormControl,
  NativeSelect,
  CircularProgress,
} from "@material-ui/core";

//material-ui.com
import { makeStyles } from "@material-ui/core/styles";

//componentes del sistema

//componentes para el boton buscar
import Button from "@material-ui/core/Button";
import CancelIcon from "@mui/icons-material/Cancel";

import { useStylesGlobal } from "configurations/styles/theme";
import { formatoArchivo } from "../Forms/typeVoucher";

//Color para la advertencia
import {
  palette,
  styleInput,
  msmSwalError,
  msmSwalExito,
} from "configurations/styles/theme";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { httpCore } from "configurations/axios";
import { getRUCEmpresa } from "redux/actions/userActions";

const useStyles = makeStyles((theme) => ({
  cardContent: {
    width: "94%",
    height: "400px",
    margin: "3%",
  },
  gridLable: {
    // paddingRight: '1%'
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  divBotonBuscar: {
    marginTop: "0.5%",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuSeleccion: {
    zIndex: "3000  ! Important",
    width: "60% !Important",
  },
  infoBusqueda: {
    marginTop: "30px",
    marginBottom: "30px",
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  fragment: {
    padding: "10px",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const UploadFileExcel = () => {
  const classes = useStyles();
  const tokenUser = useSelector((state) => state.user.tk);
  const classesGlobales = useStylesGlobal();
  const classesApp = useStylesApp();
  const [eventAnnulation, setEventAnnulation] = useState({});
  const [fileData, setFileData] = useState(null);
  const [isOver, setIsOver] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [file, setFile] = useState(null);
  const [codigo, setCodigo] = useState("");


  const dragOver = (event) => {
    event.preventDefault();
    setIsOver(true);
  };

  const dragEnter = (event) => {
    event.preventDefault();
  };

  const dragLeave = (event) => {
    event.preventDefault();
    setIsOver(false);
  };

  const ButtonPostGetFile = () => {
    const classes = useStyles();
    return (
      <>
        <button className={classes.button}>Cargar Archivo</button>
      </>
    );
  };

  const fileDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    setFileData(files[0]);
  };

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };
 
  const uploadExcel = async () => {
    setOpenLoader(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("codigo", codigo);
    let rucEmpresa = tokenUser ? getRUCEmpresa(tokenUser) : "0";
    await httpCore
      .post("/generacion/comprobantes/excel/" + rucEmpresa, formData)
      .then((response) => {
        if (response.status === 200) {
          msmSwalExito("Comprobantes enviados para autorizar exitosamente.");
          setOpenLoader(false);
          setFile(null);
        } else {
          msmSwalError("Error al enviar los comprobantes.");
          setOpenLoader(false);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          msmSwalError(
            exception.response.data.apierror
              ? exception.response.data.apierror.mensaje
                ? exception.response.data.apierror.mensaje
                : "Error al enviar los comprobantes."
              : "Error al enviar los comprobantes - Mensaje de error:" + exception.response.data.message
          );
          setOpenLoader(false);
        } else {
          msmSwalError(
            "Existen problemas en la red. Contáctese con el administrador del Sistema. - Formato de archivo incorrecto"
          );
        }
        setOpenLoader(false);
      });
  };

  return (
    <Fragment className={classes.fragment}>
      <Card className={classes.cardContent}>
        <Grid container xs={12} justify="center" alignItems="center">
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Carga de archivo para generar comprobantes"}
            avatar={<AssessmentIcon></AssessmentIcon>}
          />
        </Grid>

        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          align="center"
        >
          <Grid container>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
            <Grid item xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Los campos marcados con (
                <font color={palette.error.main}> *</font>) son obligatorios:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
          </Grid>
            
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid  item lg={2} xs={12}>
            <Typography aling="center" color="primary" variant="subtitle2">
                Formato de Archivo:
              </Typography>
          </Grid>
          <Grid  item lg={2} xs={12} >
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={codigo}
                name="codigo"
                onChange={event => setCodigo(event.target.value)}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {formatoArchivo.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errors.formatoArchivo ? (
              <p className={classesApp.errorLetters}>
                {errors.formatoArchivo}
              </p>
            ) : null}
          </Grid>
            <Grid item lg={2} xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Archivo:
                <font color={palette.error.main}> *</font>
              </Typography>
            </Grid>
            <Grid item lg={2} xs={12}>
              <input
                type="file"
                name="file"
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.cufe ? (
                <p className={classesApp.errorLetters}>{errors.cufe}</p>
              ) : null}
            </Grid>

            {/* <div className="container pl-0 pr-0">
              <div
                className={isOver ? "container-hover" : "drop-container"}
                onDragOver={dragOver}
                onDragEnter={dragEnter}
                onDragLeave={dragLeave}
                onDrop={fileDrop}
              >
                {fileData ? (
                  <p>Archivo: {fileData.name}, Cargado</p>
                ) : (
                  <div className="drop-message">
                    <div className="upload-icon"></div>
                    Agregar Archivo
                    <br />
                    <small>
                      Arrastre el archivo o{" "}
                      <font className="cert-link-btn">clic aquí</font>
                    </small>
                  </div>
                )}
              </div>
              <small className="small-message">
                El archivo debe tener una extensión '.xlsx'.
              </small>
              {fileData ? <ButtonPostGetFile /> : null}
            </div> */}
          </Grid>
          <br></br>
          <Grid>
            <Divider className={classes.divider} />
          </Grid>

          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} lg={2}>
              <Button variant="outlined" color="primary" onClick={uploadExcel}>
                Cargar Archivo
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Backdrop className={classes.backdrop} open={openLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Card>
    </Fragment>
  );
};

export default UploadFileExcel;
